import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ExternalLink, User, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from "@/components/ui/use-toast";

const LoginRedirectPage = () => {
  const { toast } = useToast();

  const handleRedirect = () => {
    toast({
      title: "🚧 Feature Not Implemented",
      description: "This feature isn't implemented yet—but don't worry! You can request it in your next prompt! 🚀",
    });
  };

  return (
    <>
      <Helmet>
        <title>Login to Learning Dashboard - PhysicsNotebook.in | Access Your Account</title>
        <meta name="description" content="Access your PhysicsNotebook.in learning dashboard. Login or signup to continue your physics learning journey with personalized content and progress tracking." />
      </Helmet>

      <section className="min-h-screen hero-gradient flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="flex justify-center">
              <div className="bg-gradient-to-r from-blue-600 to-green-500 w-24 h-24 rounded-full flex items-center justify-center">
                <User className="h-12 w-12 text-white" />
              </div>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Access Your <span className="gradient-text">Learning Dashboard</span>
            </h1>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Login to your personalized physics learning dashboard where you can access comprehensive notes, 
              practice problems, track your progress, and get AI-powered recommendations.
            </p>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
              <div className="flex items-center justify-center mb-4">
                <ExternalLink className="h-8 w-8 text-blue-600 mr-3" />
                <h2 className="text-2xl font-semibold text-gray-900">Dashboard Coming Soon!</h2>
              </div>
              <p className="text-gray-600 mb-6">
                Our secure learning platform at <strong>dlp.physicsnotebook.in</strong> is under construction. 
                Login and signup functionality will be available soon!
              </p>

              <Button 
                onClick={handleRedirect}
                className="btn-primary text-white px-8 py-3 text-lg w-full sm:w-auto"
              >
                Login / Sign Up
                <ArrowRight className="h-5 w-5 ml-2" />
              </Button>
            </div>

            <div className="pt-8 border-t border-gray-200">
              <p className="text-gray-500 text-sm mb-4">
                In the meantime, you can explore other parts of our site:
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/" className="text-blue-600 hover:text-blue-800 underline">
                  Return to Homepage
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default LoginRedirectPage;
